import { LogOut } from "lucide-react";
import type { ReactNode } from "react";
import { Button } from "@altek/ui/components/ui/Button";
import { ScreenTitleContext } from "./document-title";

/**
 * UYGULAMANIN YERİNE ÇİZİLEN EKRANLAR — engelleyen müşteri seçici ve kullanıma kapalı abonelik
 * (9 Ekim 2026, 5. tur; giriş ekranı taramasının kabuğa bildirdiği iki bulgu).
 *
 * SEKME ADI. İki ekran da adını `useScreenTitle` ile söylüyor («Müşteri seçin», «Aboneliğiniz
 * kullanıma kapalı»), ama `AppLayout` onları `ScreenTitleContext`'in DIŞINDA çiziyordu: kanca
 * başlığı doğrudan yazıyor, kabuğun kendi başlık etkisi (ebeveyn, SONRA çalışıyor) adresin adını
 * («Panelim») üstüne yazıyordu. Sekme, ekranda olmayan bir sayfanın adını taşıyordu. Bu kap aynı
 * yuvayı veriyor; ad kabuğun tek başlık yazıcısından geçiyor.
 *
 * ÇIKIŞ YOLU. Engelleyen müşteri seçicide çıkmanın yolu yoktu: kişi bir müşteri seçmeden
 * oturumu kapatamıyordu — paylaşılan bir bilgisayarda yanlış hesapla girmiş birinin ekranı
 * bırakmasının tek yolu tarayıcıyı kapatmaktı. Seçicinin kendisi `features/auth`'un; düğme
 * onun dışında, kartın ALTINDA ve sekme sırasında seçeneklerden SONRA duruyor (ilk Tab'ın
 * yanlışlıkla çıkış yaptırmaması için). Abonelik ekranının kendi çıkış düğmesi var, orada
 * `onSignOut` verilmiyor.
 */
export function BlockingScreen({
  setTitle,
  onSignOut,
  signingOut = false,
  children,
}: {
  /** Kabuğun başlık yuvası (`AppLayout`'un `setTitleOverride`'ı). */
  setTitle: (title: string | null) => void;
  /** Verilirse kartın altında «Çıkış yap». */
  onSignOut?: (() => void) | undefined;
  signingOut?: boolean | undefined;
  children: ReactNode;
}) {
  return (
    <ScreenTitleContext.Provider value={setTitle}>
      {children}
      {onSignOut ? (
        <div className="pointer-events-none fixed inset-x-0 bottom-4 flex justify-center px-4">
          <Button
            variant="ghost"
            className="pointer-events-auto max-md:min-h-11"
            icon={<LogOut size={16} aria-hidden="true" />}
            loading={signingOut}
            onClick={onSignOut}
          >
            Çıkış yap
          </Button>
        </div>
      ) : null}
    </ScreenTitleContext.Provider>
  );
}
